import Flickity from 'flickity'
import 'flickity-imagesloaded'

const els = document.querySelectorAll('.element-ticker')

const sliders = []
const tickerSpeed = 1

export default {
  can: () => els.length,
  run: () => {
    els.forEach((el) => {
      const flickity = new Flickity(el.querySelector('.images'), {
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        wrapAround: true,
        imagesLoaded: true,
        selectedAttraction: 0.015,
        friction: 0.25,
      })

      const slider = {}

      slider.flickity = flickity
      slider.update = () => {
        flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth
        flickity.selectedIndex = flickity.dragEndRestingSelect()
        flickity.updateSelectedSlide()
        flickity.settle(flickity.x)

        window.requestAnimationFrame(slider.update)
      }

      sliders.push(slider)
    })

    sliders.forEach((slider) => slider.update())
  },
}
